import { apiPost } from '../api'

export const resolve_flagged_learner = data => {
  return apiPost({
    endpoint: 'attendance/resolve_flagged_learner',
    data: data
  })
}
